import { createAsyncAction, createAction } from './creator';

export const SYSTEM_GET_SETTING = 'SYSTEM_GET_SETTING';
export const SYSTEM_SET_SETTING = 'SYSTEM_SET_SETTING';
export const SYSTEM_GET_WALLET = 'SYSTEM_GET_WALLET';
export const SYSTEM_SET_WALLET = 'SYSTEM_SET_WALLET';
export const SYSTEM_SET_AGREEMENT = 'SYSTEM_SET_AGREEMENT';
export const SYSTEM_GET_MENU = 'SYSTEM_GET_MENU';
export const SYSTEM_SET_MENU = 'SYSTEM_SET_MENU';
export const SYSTEM_SET_MENU_KEYS = 'SYSTEM_SET_MENU_KEYS';
export const SYSTEM_GET_ROLEMAP = 'SYSTEM_GET_ROLEMAP';
// Theme images (favicon/mainLogo/squareLogo/clientLoginBg) from /v2/platform/setting/theme.
// 主题图片（favicon/mainLogo/squareLogo/clientLoginBg），从 /v2/platform/setting/theme 接口获取。
export const SYSTEM_GET_THEME = 'SYSTEM_GET_THEME';

export const setMenuKeys = createAction(SYSTEM_SET_MENU_KEYS);
export const getSetting = createAsyncAction(SYSTEM_GET_SETTING);
export const setSetting = createAsyncAction(SYSTEM_SET_SETTING);
export const getWallet = createAsyncAction(SYSTEM_GET_WALLET);
export const setWallet = createAsyncAction(SYSTEM_SET_WALLET);
export const setAgreement = createAsyncAction(SYSTEM_SET_AGREEMENT);
export const getMenu = createAsyncAction(SYSTEM_GET_MENU);
export const setMenu = createAsyncAction(SYSTEM_SET_MENU);
export const getRoleMap = createAsyncAction(SYSTEM_GET_ROLEMAP);
export const getTheme = createAsyncAction(SYSTEM_GET_THEME);
